import React from "react";
import { Bell, ChevronLeft, SlidersHorizontal } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const notifications = [
  {
    id: 1,
    title: "Approve Successful!",
    message: "Your parcel has been securely stored with your approval.",
    type: "success",
    icon: "✅",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
  {
    id: 2,
    title: "Delivery Denied!",
    message: "Your parcel has not stored because you denied approval.",
    type: "error",
    icon: "❌",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
  {
    id: 3,
    title: "Unlocked Your Parcel!",
    message: "OTP - 505050 Scanner 📷",
    type: "info",
    icon: "🔓",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
  {
    id: 4,
    title: "Parcel Received!",
    message: "Thank you for using our service.",
    type: "green",
    icon: "📦",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
  {
    id: 5,
    title: "Feedback :)",
    message: "Give us feedback to improve our services",
    type: "yellow",
    icon: "⭐️⭐️⭐️",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
  {
    id: 6,
    title: "The Souled Store Men's",
    message: "Promotional Message",
    type: "promo",
    icon: "🛍️",
    date: "Mar 21, 2025",
    time: "3:30pm",
  },
];

const getTypeClass = (type) => {
  switch (type) {
    case "success": return "border-blue-300 bg-blue-50";
    case "error": return "border-red-300 bg-red-50";
    case "info": return "border-blue-300 bg-blue-50";
    case "green": return "border-green-300 bg-green-50";
    case "yellow": return "border-yellow-300 bg-yellow-50";
    default: return "bg-gray-50";
  }
};

const Notification = () => {
    const navigate = useNavigate();

  return (
    <div className="bg-gray-100 min-h-screen">
      <header className="bg-[#004990] text-white flex items-center justify-between px-4 py-3">
        <button  onClick={() => navigate(-1)}><ChevronLeft /></button>
        <div className="flex items-center space-x-2">
          <div className="relative">
            <Bell size={20} />
            {/* <span className="absolute -top-1 -right-2 bg-red-600 text-xs rounded-full px-1">10</span> */}
          </div>
          <h1 className="text-lg font-semibold">Notifications</h1>
        </div>
        <SlidersHorizontal />
      </header>

      <main className="flex flex-col items-center space-y-4 py-6">
        {notifications.map((note) => (
          <div
            key={note.id}
            className={`w-4/5 p-4 border rounded-xl ${getTypeClass(note.type)} flex justify-between items-start`}
          >
            <div className="flex items-start space-x-4">
              <div className="text-2xl">{note.icon}</div>
              <div>
                <h2 className="font-semibold">{note.title}</h2>
                <p className="text-sm text-gray-700">{note.message}</p>
              </div>
            </div>
            <div className="text-xs text-gray-500 whitespace-nowrap text-right">
              <p>{note.date},</p>
              <p>{note.time}</p>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
};

export default Notification;
